import styles from './modal.module.scss';
import './modal.scss';
import PropTypes from 'prop-types';
import {Modal} from 'antd';

const DBModal = props => {
  const {
    isOpen,
    handleClose,
    content,
    zIndex,
    destroyOnClose,
    width,
    className,
  } = props;

  return (
    <Modal
      className={`${styles['modal-container']}${
        className ? ` ${className}` : ''
      }`}
      open={isOpen}
      centered
      width={width || 520}
      onCancel={handleClose}
      footer={null}
      zIndex={zIndex || 1000}
      destroyOnClose={destroyOnClose}>
      {content}
    </Modal>
  );
};

export default DBModal;
DBModal.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  content: PropTypes.any,
  zIndex: PropTypes.number,
  width: PropTypes.number,
};
